export enum ApprovalsTab {
  All = 'ALL',
  OnValidation = 'ON_VALIDATION',
  Rejected = 'REJECTED',
  Validated = 'VALIDATED',
}
